import { Component } from 'react';
import Container from '../ui/Container';

/**
 * Catches render-time errors so a single broken component cannot blank the
 * whole site. Error boundaries must be class components in React.
 */
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Console output only -- this static build has no error-reporting service
    // and must never send diagnostics anywhere without being configured to.
    // eslint-disable-next-line no-console
    console.error('Unexpected application error:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Container>
          <div className="section" role="alert">
            <h1>Something went wrong</h1>
            <p className="text-muted">
              This page could not be displayed. Please refresh the browser, or
              return to the home page and try again.
            </p>
            <a className="btn btn--primary" href="/">
              Return to the home page
            </a>
          </div>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
